export default "__VITE_ASSET__cQMHBbjf__"